
























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class AnalyticsArrowRight extends Vue {
  @Prop({ default: '12' }) readonly width?: string;
  @Prop({ default: '12' }) readonly height?: string;
  @Prop({ default: '#8D949E' }) readonly color?: string;
}
